import ApiService from '../apiservice'

export default class ConfiguracaoTarefaService extends ApiService {
  constructor() {
    super('/configuracaoTarefa')
  }

  listarTarefas(empresa) {
    return this.get(`/listaTarefas/${empresa}`);
  }

  cadastrarNovaTarefa(configuracaoTarefa) {
    return this.post('/',configuracaoTarefa);
  }

  consultarConfiguracaoTarefa(codigo) {
    return this.get(`/consulta/${codigo}`);
  }

  consultarConfiguracoesSemTarefaCriadora(codigo,empresa) {
    return this.get(`/listarSemTarefas?codigo=${codigo}&empresa=${empresa}`);
  }

  adicionarTarefa(tarefaPrincipal, subTarefa) {
    return this.put(`/adicionarTarefa?tarefaPrincipal=${tarefaPrincipal}&subTarefa=${subTarefa}`);
  }

  consultarSubTarefas(codigo) {
    return this.get(`/subTarefas/${codigo}`);
  }

  desvincularTarefa(codigo) {
    return this.put(`/desvincular/${codigo}`);
  }

  alterarConfiguracaotarefa(configuracao) {
    return this.put('/',configuracao);
  }
}